const rotateBorderKeyframes = {
    '@keyframes rotateWithPause': {
        // 0% ~ 5% (0초 ~ 3초): 360도 회전하며 서서히 나타남
        '0%': { transform: 'rotate(0deg)', opacity: 0 },
        '2%': { opacity: 1 },
        '5%': { transform: 'rotate(360deg)', opacity: 1 },
        // 5% ~ 7% (3초 ~ 4.2초): 회전 완료 후 페이드 아웃
        '7%': { transform: 'rotate(360deg)', opacity: 0 },
        // 7% ~ 100% (4.2초 ~ 60초): 투명한 상태로 대기
        '100%': { transform: 'rotate(360deg)', opacity: 0 },
    },
};

const shakeKeyframes = {
    '@keyframes shake': {
        '0%': { marginLeft: '0px', marginRight: '0px' },
        '25%': { marginLeft: '-10px', marginRight: '10px' },
        '50%': { marginLeft: '10px', marginRight: '-10px' },
        '75%': { marginLeft: '-10px', marginRight: '10px' },
        '100%': { marginLeft: '0px', marginRight: '0px' },
    },
};

// 금속 광택 반사 효과 (60초 주기, 처음 3초간 빛이 왼쪽→오른쪽으로 스윕)
// step-end: 5%→100% 구간을 즉시 점프로 처리하여 루프 끊김 없음
// 그라디언트 양 끝(0%~40%, 60%~100%)이 동일한 어두운 금색이므로 점프가 시각적으로 보이지 않음
const goldShineKeyframes = {
    '@keyframes goldShine': {
        '0%': { backgroundPosition: '100% center' },
        '5%': { backgroundPosition: '0% center', animationTimingFunction: 'step-end' },
        '100%': { backgroundPosition: '100% center' },
    },
};

export { rotateBorderKeyframes, shakeKeyframes, goldShineKeyframes };
